import { stageLabel, stageTone } from 'lib/dynamicModificationStages';

import './DynamicStageChip.scss';

/** A dynamic modification stage: its number and name, colored by what it does. */
export default function DynamicStageChip({ stage, label, title }) {
  return (
    <span className={`qm-dynamic-stage-chip tone-${stageTone(stage)}`} title={title}>
      <strong>{stage.stageNo}</strong> {label ?? (stage.name || stageLabel(stage))}
    </span>
  );
}
